import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import type { Rule } from 'ant-design-vue/es/form';


export default /*@__PURE__*/_defineComponent({
  __name: 'form-privacy-consent-field',
  props: {
    modelValue: { type: Boolean },
    policyUrl: { default: 'https://vgbitrix.osinit.com/politika.php' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const formPrivacyConsentRules: Rule[] = [{ required: true, message: '', type: 'boolean' }];

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createBlock(_component_a_form_item, {
    name: "privacy",
    "value-prop-name": "checked",
    rules: formPrivacyConsentRules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_checkbox, {
        class: "form-privacy-consent-field",
        checked: __props.modelValue,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", { style: { color: '#1A01BA' } }, "Согласен ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "и принимаю ", -1)),
          _createElementVNode("a", {
            href: __props.policyUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, "политику конфиденциальности", 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["checked"])
    ]),
    _: 1
  }))
}
}

})